import { css } from 'lit';

export const desktopStyles = css`

    .k-desktop-app {
      overscroll-behavior: none;
      font-family: 'Arial', sans-serif;
      height: 100%;
      width: 100%;

      height:100%;
      width:100%;
    }
`;


export const commonStyles = css`

  .hidden {
    display:none;
  }

  .flex {
    display:flex;
    align-items:center;
  }

  .flex-fill {
    flex:1;
  }

  .text-center {
    text-align:center;
  }
    
  .ripple {
    position: relative;
    overflow: hidden;
    transform: translate3d(0, 0, 0);
  }
  .ripple:after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    background-image: radial-gradient(circle, #000 10%, transparent 10.01%);
    background-repeat: no-repeat;
    background-position: 50%;
    transform: scale(10, 10);
    opacity: 0;
    transition: transform .5s, opacity 1s;
  }
  .ripple:active:after {
    transform: scale(0, 0);
    opacity: .2;
    transition: 0s;
  }

`



export const formStyles = css`
  .form-form .form-row {
    display: flex;
    align-items: center;
  }

  .form-form div[slot="tab"] {
    padding: 8px 6px;
  }

  .form-form .form-fieldset {
    border: 1px solid #ccc;
    padding: 4px;
    margin-bottom: 4px;
  }

  .form-form .form-fieldset legend {
    font-weight: bold;
    padding-inline-start: 2px;
    margin-bottom: 4px;
  }

  .form-form .form-field {
    box-sizing: border-box;
    padding-bottom: 4px;
    padding-right: 4px;
    padding-left: 4px;
  }

  .form-form .form-field[size='1'], .form-form .form-field:not([size]) {
    flex:1;
  }

  .form-form .form-field[size='2'] {
    flex:2;
  }

  .form-form .form-field[size='3'] {
    flex:3;
  }

  .form-form .form-field[size='4'] {
    flex:4;
  }

  .form-form .form-field[size='5'] {
    flex:5;
  }

  .form-form .form-field[size='6'] {
    flex:6;
  }

  .form-form .form-field[size='7'] {
    flex:7;
  }

  .form-form .form-field[size='8'] {
    flex:8;
  }

  .form-form .form-field[size='9'] {
    flex:9;
  }

  .form-form .form-field[size='10'] {
    flex:10;
  }

  .form-form .form-field[size='11'] {
    flex:11;
  }

  .form-form .form-field[size='12'] {
    flex:12;
  }

  .form-form .form-field[size='none'] {
    flex:undefined;
  }


  .form-form .form-field label {
    display: block;
    font-weight: bold;
    font-size: smaller;
  }

  .form-form .form-field input, .form-form .form-field select, .form-form .form-field textarea, .form-form .form-field k-input {
    width: 100%;
    padding: 6px 8px;
    box-sizing: border-box;
    border: 1px solid #ddd;
    transition: border 0.5s;
    outline: none;
  }

  .form-form .form-field k-input {
    width: 100%;
    border: 1px solid #ddd;
    transition: border 0.5s;
    background: white;
    outline: none;
    padding: 0px;
  }


  .form-form .form-field input[type=checkbox], .form-form .form-field input[type=radio]{
    width: 1.2em;
    height: 1.8em;
    border: none;
    padding: inherit;
    margin: auto;
  }

  .form-form .form-field input[type='color'] {
    padding:0px;
  }

  .form-form input:focus, .form-form .form-field select:focus, .form-form .form-field textarea:focus, .form-form .form-field k-input:focus {
    border: 1px solid blue;
    background: lightblue;
  }

  

  .form-form input:invalid, .form-form .form-field select:invalid, .form-form .form-field textarea:invalid {
    border: 1px solid red;
    background: #ff000030;
  }
  

  .form-form .form-field input[type=checkbox]:focus, .form-form .form-field input[type=radio]:focus  {
    outline: 1px solid blue;
    background: lightblue;
  }

  .form-field .radio-value, .form-field.radio-value {
    display:flex;
    align-items:center;
  }

  .form-field .radio-value span, .form-field.radio-value span {
    flex: 1;
    padding-left: 6px;
  }

  .form-form .form-field.with-buttons {
    display: flex;
    flex-wrap: wrap;
  }

  .form-form .form-field.with-buttons label {
    width: 100%;
  }

  .form-form .form-field.no-label {
    padding-top: 1em;
  }


  .form-form .form-field .field-input {
    flex: 1;
  }

  .form-form .form-field .field-buttons k-icon{
    --icon-button-padding: 1px;
    width: 24px;
    height: 24px;
    margin-left: 4px;
    position: relative;
    top: 2px;
  }

  .form-container {
    margin: 4px 2px 2px 2px;
    padding: 4px;
    border: 1px solid lavender;
  }

  .form .footer, .form-footer {
    height: 46px;
    display: flex;

    justify-content: flex-end;
    align-items: center;
    margin: 4px 2px;
    padding: 4px 12px;
    border: 1px solid lavender;
  }

  .form .button-separator, .form-button-separator {
    display: inline-block;
    width: 16px;
    height: 16px;
  }
  


  .form-card {
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    background: white;
    margin-top: 20px;
    padding: 12px;
  }

  /* On mouse-over, add a deeper shadow */
  .form-card:hover {
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
  }

  .form-card-title {
    font-size: larger;
    font-weight: bold;
  }

`


export const textStyles = css`
  .text-bold {
    font-weight: bold;
  }

  .text-larger {
    font-size: larger;
  }

`




export const waitStyles = css`
    .wait-overlay {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: rgba(0,0,0,.5);
      z-index: 999999;
    }

    .wait-overlay__wrapper {
      width: 100%;
      height: 100%;
      position: relative;
    }

    .wait-overlay__spinner {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }


    .lds-ring {
      display: inline-block;
      position: relative;
      width: 80px;
      height: 80px;
    }
    .lds-ring div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 64px;
      height: 64px;
      margin: 8px;
      border: 8px solid #fff;
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: #fff transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
      animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
      animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
      animation-delay: -0.15s;
    }
    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

`
